module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/selected-file-b026b6fc42561a9a977a0b2e1a728728.svg";